import {
  Avatar,
  Box,
  IconButton,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import NotesCard from "./NotesCard";
import type { OrganizerCardProps } from "../../../types/types";
import {
  LocationIcon,
  MessageIcon,
  PhoneIcon,
} from "../../../../../../components/icons";

interface ClientInfoCardProps {
  client?: OrganizerCardProps;
}

export default function ClientInfoCard({ client }: ClientInfoCardProps) {
  const getInitials = (name?: string) => {
    if (!name) return "";

    const parts = name.trim().split(" ");

    if (parts.length === 1) {
      return parts[0][0].toUpperCase();
    }

    return parts[0][0].toUpperCase() + parts[parts.length - 1][0].toUpperCase();
  };

  return (
    <Paper
      sx={{ flex: 1, borderRadius: "12px", p: 2, boxShadow: 0, height: "100%" }}
    >
      <Stack spacing={2}>
        {/* Header */}
        <Stack direction="row" spacing={2} alignItems="center">
          <Avatar
            src={client?.contact_image || undefined}
            sx={{
              width: 56,
              height: 56,
              bgcolor: "#094b9b",
              fontWeight: 700,
              fontSize: "14px",
            }}
          >
            {!client?.contact_image && getInitials(client?.name)}
          </Avatar>

          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "18px",
                color: "black",
              }}
            >
              {client?.name}
            </Typography>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "14px",
                color: "black",
              }}
            >
              {client?.relation}
            </Typography>
          </Box>
          <Stack direction="row" spacing={1}>
            <IconButton
              sx={{
                bgcolor: "#f7e6d8",
                width: 30,
                height: 30,
                "&:hover": { bgcolor: "#f0d9c9" },
              }}
            >
              <PhoneIcon sx={{ fontSize: 16 }} />
            </IconButton>
            <IconButton
              sx={{
                bgcolor: "#f7e6d8",
                width: 30,
                height: 30,
                "&:hover": { bgcolor: "#f0d9c9" },
              }}
            >
              <MessageIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Stack>
        </Stack>

        {client?.address?.trim() && client.address !== "N/A" && (
          <Box
            sx={{
              bgcolor: "#f0f4f8",
              borderRadius: "20px",
              display: "flex",
              alignItems: "center",
              p: 1.5,
              gap: 1,
            }}
          >
            <LocationIcon sx={{ fontSize: 16 }} />
            <Typography>{client.address}</Typography>
          </Box>
        )}

        {/* Notes sections */}
        <NotesCard title="Special Notes" content={client?.specialNotes || ""} />
        <NotesCard title="Notes" content={client?.notes || ""} />
      </Stack>
    </Paper>
  );
}
